// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_2c3e10ab","outerContainer":"_9285242b","secondaryToolbar":"_3c773e0b","doorHangerRight":"a15a6716","toolbarContainer":"_7376eb7e","toolbarViewerMiddle":"c6137d79","progressBar":"e5e48ca0","back-to-application":"_366f059b","root":"_876f0925","panel":"_5558c7a1","panelPrimary":"d54d14ae","panelContainer":"_51af7b50","panelSecondary":"_76016d53","tabWrapper":"_987e2b9d","tab":"_82046f15","tabIcon":"_9d56c558","tabActive":"_96f097b3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/Navigation/PatientPortalCategory/index.styl
// module id = 5044
// module chunks = 39